var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-detail" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.wpBussChannelDetail"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.manageChannelDetail"))),
        ]),
      ]),
      _vm._v(" "),
      _vm.shouldShowIframe
        ? [
            _c(
              "div",
              { staticClass: "onboarding-wrapper" },
              [
                _c(
                  "SupsisButton",
                  {
                    staticClass: "integration-button",
                    attrs: { type: "primary", large: "", primary: "" },
                    on: { click: _vm.openOnboardingLink },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("auto.gupshupSetupWhatsAppIntegration")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  [
                    _c("template", { slot: "title" }, [
                      _vm._v(
                        "\n                    WhatsApp Business App kullanırken aynı hattınızı WhatsApp Business API'de de kullanabilirsiniz.\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        staticClass: "integration-button",
                        attrs: {
                          loading: _vm.coexistenceLoading,
                          xlarge: "",
                          ghost: !_vm.isCoexistenceEnabled,
                          primary: _vm.isCoexistenceEnabled,
                        },
                        on: { click: _vm.toggleCoexistence },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.isCoexistenceEnabled
                                ? _vm.$t("auto.gupshupCoexistenceDisable")
                                : _vm.$t("auto.gupshupCoexistenceEnable")
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "integration-button",
                    attrs: { xlarge: "", ghost: "", icon: "help" },
                    on: { click: _vm.connectSupportTeamRequest },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("auto.gupshupGetHelp")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("a-alert", {
                  staticClass: "mt-4",
                  attrs: {
                    message: "Bilgilendirme",
                    description:
                      "Eğer WhatsApp hattınızı başarılı bir şekilde tanımladıysanız, bu ekranın güncellenmesi biraz zaman alabilir.",
                    type: "info",
                    "show-icon": "",
                  },
                }),
              ],
              1
            ),
          ]
        : [
            _c("a-form", [
              _c(
                "div",
                { staticClass: "form-wrapper" },
                [
                  _c(
                    "a-alert",
                    { attrs: { message: "Webhook Address", type: "success" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "description" }, slot: "description" },
                        [
                          _c("div", { staticClass: "webhook-info" }, [
                            _c(
                              "span",
                              [
                                _c("a-icon", {
                                  attrs: { type: "copy" },
                                  on: { click: _vm.copyWebhookAddress },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("OLD: " + _vm._s(_vm.getWebhookAddress())),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "webhook-info" }, [
                            _c(
                              "span",
                              [
                                _c("a-icon", {
                                  attrs: { type: "copy" },
                                  on: {
                                    click: function () {
                                      return _vm.copyWebhookAddress(true)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("NEW: https://webhook.supsis.ai/waba"),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("whatsapp_business_api.channelName"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t(
                            "whatsapp_business_api.channelName"
                          ),
                          name: "channelName",
                        },
                        model: {
                          value: _vm.clone.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone, "name", $$v)
                          },
                          expression: "clone.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.debugMode
                    ? _c("div", { staticClass: "input-wrapper" }, [
                        _c("label", [_vm._v("API Key ")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "secure-input-wrapper" },
                          [
                            _c("a-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              staticClass: "secure-input",
                              attrs: {
                                type: _vm.apiKeyVisible ? "text" : "password",
                                disabled: !_vm.apiKeyEditable,
                                placeholder: "API Key ",
                                name: "apiKey",
                              },
                              on: { focus: _vm.showWarning },
                              model: {
                                value: _vm.clone.payload.apiKey,
                                callback: function ($$v) {
                                  _vm.$set(_vm.clone.payload, "apiKey", $$v)
                                },
                                expression: "clone.payload.apiKey",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-actions" }, [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons action-icon",
                                  class: { active: _vm.apiKeyVisible },
                                  attrs: { title: "Görüntüle" },
                                  on: { click: _vm.toggleApiKeyVisibility },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.apiKeyVisible
                                          ? "visibility"
                                          : "visibility_off"
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons action-icon",
                                  class: { active: _vm.apiKeyEditable },
                                  attrs: { title: "Düzenle" },
                                  on: { click: _vm.toggleApiKeyEdit },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.apiKeyEditable ? "edit" : "edit_off"
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c("label", [_vm._v("App ID")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "secure-input-wrapper" },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "secure-input",
                          attrs: {
                            type: _vm.appIdVisible ? "text" : "password",
                            disabled: !_vm.appIdEditable,
                            placeholder: "App ID ",
                            name: "appId",
                          },
                          on: { focus: _vm.showWarning },
                          model: {
                            value: _vm.clone.payload.appId,
                            callback: function ($$v) {
                              _vm.$set(_vm.clone.payload, "appId", $$v)
                            },
                            expression: "clone.payload.appId",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-actions" }, [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons action-icon",
                              class: { active: _vm.appIdVisible },
                              attrs: { title: "Görüntüle" },
                              on: { click: _vm.toggleAppIdVisibility },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.appIdVisible
                                      ? "visibility"
                                      : "visibility_off"
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "i",
                            {
                              staticClass: "material-icons action-icon",
                              class: { active: _vm.appIdEditable },
                              attrs: { title: "Düzenle" },
                              on: { click: _vm.toggleAppIdEdit },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.appIdEditable ? "edit" : "edit_off"
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c("label", [_vm._v("App Name")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "secure-input-wrapper" },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "secure-input",
                          attrs: {
                            type: _vm.appNameVisible ? "text" : "password",
                            disabled: !_vm.appNameEditable,
                            placeholder: "App Name ",
                            name: "appName",
                          },
                          on: { focus: _vm.showWarning },
                          model: {
                            value: _vm.clone.payload.appName,
                            callback: function ($$v) {
                              _vm.$set(_vm.clone.payload, "appName", $$v)
                            },
                            expression: "clone.payload.appName",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-actions" }, [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons action-icon",
                              class: { active: _vm.appNameVisible },
                              attrs: { title: "Görüntüle" },
                              on: { click: _vm.toggleAppNameVisibility },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.appNameVisible
                                      ? "visibility"
                                      : "visibility_off"
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "i",
                            {
                              staticClass: "material-icons action-icon",
                              class: { active: _vm.appNameEditable },
                              attrs: { title: "Düzenle" },
                              on: { click: _vm.toggleAppNameEdit },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.appNameEditable ? "edit" : "edit_off"
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("whatsapp_business_api.phoneNumberE164")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t(
                            "whatsapp_business_api.phoneNumberE164Place"
                          ),
                          name: "phoneNumber",
                        },
                        on: { focus: _vm.showWarning },
                        model: {
                          value: _vm.clone.payload.phoneNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.payload, "phoneNumber", $$v)
                          },
                          expression: "clone.payload.phoneNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("ChannelForwardSetting", {
              attrs: { channel: _vm.clone },
              on: {
                input: function (c) {
                  return (_vm.clone = c)
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "form-footer" }, [
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "pr-confirm-btn",
                      attrs: { type: "primary", disabled: _vm.loading },
                      on: { click: _vm.handleSave },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.update")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }